export default ['JsonRPCService', (JsonRPCService) => {
    return {
        getStatements: (producerCode) => {
            return JsonRPCService.send('bc', 'gatewaycommission/commission', 'getStatements', [producerCode]);
        },
        getStatementPolicies: (statement) => {
            return JsonRPCService.send('bc', 'gatewaycommission/commission', 'getStatementPolicies', [statement]);
        }
    };
}];